import { PropsWithChildren } from "react";
import LogoTitle from "../molecules/LogoTitle";
import { Head } from "@inertiajs/react";
import { topKeyVisualUrl } from "@/api/image/api";

/**
 * サイトトップ専用の外殻。
 *
 * 背景は常に暗いキービジュアルのため、色はテーマのトークンではなく固定値で書く。
 * トークンはライト／ダークで切り替わるので、ライトモードで暗い画像の上に濃い文字が乗ってしまう。
 */
export default function TopLayout({
  pageTitle,
  children,
}: PropsWithChildren & { pageTitle: string }) {
  return (
    <div
      className="relative flex min-h-screen flex-col bg-cover text-white animate-fade-in"
      style={{
        // 中央の文字の背面だけ画像を沈め、図柄が多い箇所でも見出しと導線を読めるようにする
        backgroundImage: `radial-gradient(ellipse 60% 45% at 50% 50%, rgb(2 6 23 / 0.6), rgb(2 6 23 / 0) 100%), url(${topKeyVisualUrl()})`,
        backgroundPosition: "center",
      }}
    >
      <Head title={pageTitle} />

      <header className="w-full">
        <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center w-full">
          <LogoTitle isTop />

          {/*
            サイト概要・仕様は Laravel のルートではなく、src/docsSite（VitePress）が
            生成した静的ページ。route() では引けないためパスを直接書く。
            対応は docs/features/publicDocsSite.md を参照。
          */}
          <nav className="md:ml-auto flex flex-wrap items-center justify-center text-md font-bold">
            <a href="/site_overview" className="mr-5 hover:text-slate-300">
              サイト概要
            </a>
            <a href="/specification" className="mr-5 hover:text-slate-300">
              仕様
            </a>
            {/* 塗りは本文の「全体概要を表示」だけに与えるため、ここは線にする */}
            <a
              href={route("register")}
              className="top-outline-button rounded-3xl py-3 px-5 text-sm"
            >
              アカウント登録
            </a>
          </nav>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center">
        {children}
      </main>

      <footer className="w-full font-bold">
        <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
          <p className="text-md text-center sm:text-left">
            <a
              href="https://mushiki.com"
              className="ml-1"
              target="_blank"
              rel="noopener noreferrer"
            >
              © 2024 無式 Inc.
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
